import { push } from 'react-router-redux';
import { call, put, select } from 'redux-saga/effects';

import { ApiErrorTypes } from '../../lib/error/ApiError';
import { getMusicIdFromPandoraId } from '../../lib/PandoraIdUtil';
import * as Services from '../../services';
import Logger from '../../tools/Logger';
import * as Utils from '../../utils';

const log = Logger.child({ component: 'workers/Music' });

function* handleError(e, redirectOnNotFound) {
  if (e.errorType === ApiErrorTypes.NOT_FOUND) {
    if (redirectOnNotFound) {
      yield put(push(Utils.Route.getNotFoundPath()));
    }
  } else {
    throw e;
  }
}

/**
 * Handles User action GET_ARTIST
 *
 * @param  {object} action - the current action
 */
export function* getArtist(action) {
  const { token, redirectOnNotFound } = action.data;
  // sometimes the token will be a musicId, sometimes an seoToken
  let artist = yield call(yield select(Utils.Music.createGetArtistByMusicIdSelector), token);
  artist = artist || (yield call(yield select(Utils.Music.createGetArtistByTokenSelector), token));

  if (!(yield call(Utils.Music.artistHasFullInfo, artist))) {
    try {
      yield call(Services.Music.getArtist, token);
    } catch (e) {
      if (e.errorType === ApiErrorTypes.NOT_FOUND) {
        try {
          yield call(Services.Music.getComposer, token);
        } catch (err) {
          yield call(handleError, err, redirectOnNotFound);
        }
      } else {
        throw e;
      }
    }
  }
}

/**
 * Handles User action GET_ALBUM
 *
 * @param  {object} action - the current action
 */
export function* getAlbum(action) {
  const { token, getAlbumArtist, redirectOnNotFound } = action.data;
  let album = yield call(yield select(Utils.Music.createGetAlbumByMusicIdSelector), token);
  album = album || (yield call(yield select(Utils.Music.createGetAlbumByTokenSelector), token));

  if (!(yield call(Utils.Music.albumHasFullInfo, album))) {
    try {
      yield call(Services.Music.getAlbum, token, getAlbumArtist);
    } catch (e) {
      yield call(handleError, e, redirectOnNotFound);
    }
  }
}

/**
 * Handles User action GET_TRACK
 *
 * @param  {object} action - the current action
 */
export function* getTrack(action) {
  const { token, redirectOnNotFound } = action.data;
  let track = yield select(Utils.Music.getTrackFromState, token);
  track = track || (yield select(Utils.Music.getTrackFromStateBySeoToken, token));
  if (!(yield call(Utils.Music.trackHasFullInfo, track))) {
    try {
      if (token) {
        yield call(Services.Music.getTrack, token);
      } else {
        log.warn('Track token is undefined');
      }
    } catch (e) {
      yield call(handleError, e, redirectOnNotFound);
    }
  }
}

/**
 * Handles User action GET_LYRICS
 *
 * @param  {object} action - the current action
 */
export function* getLyrics(action) {
  const { pandoraId } = action.data;
  const lyrics = yield select(Utils.Music.getFullLyricsFromState, pandoraId);

  if (!lyrics) {
    // eslint-disable-next-line require-atomic-updates
    action.data.trackId = getMusicIdFromPandoraId(pandoraId); // todo: convert full lyrics to use catalog - WEBCLIENT-2523
    // eslint-disable-next-line require-atomic-updates
    action.data.checksum = ''; // legacy API requirement
    // eslint-disable-next-line require-atomic-updates
    action.data.lyricId = ''; // legacy API requirement
    yield call(Services.Music.getFullLyrics, { ...action.data });
  }
}
